import React, { useEffect, useState } from "react";
import ReactDom from "react-dom";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Overlay = function Overlay(_ref) {
  var visible = _ref.visible,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    onClick: onClick,
    className: "fixed z-30 inset-0   overflow-y-auto h-full w-[10%]" + (visible ? " block" : " hidden"),
    id: "my-modal"
  });
};
var CartSidebar = function CartSidebar(_ref2) {
  var className = _ref2.className,
    visible = _ref2.visible,
    onClick = _ref2.onClick,
    children = _ref2.children,
    onlyMobile = _ref2.onlyMobile,
    survey = _ref2.survey;
  useEffect(function () {
    var parentElement = document.getElementById("root"); // Target the root div or change to the correct parent container
    if (parentElement) {
      if (visible) {
        parentElement.classList.add("mod-open");
      } else {
        parentElement.classList.remove("mod-open");
      }
    }
    // Cleanup on unmount
    return function () {
      if (parentElement) {
        parentElement.classList.remove("mod-open");
      }
    };
  }, [visible]);
  return /*#__PURE__*/ReactDom.createPortal(/*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Overlay, {
      visible: visible,
      onClick: onClick
    }), visible && /*#__PURE__*/_jsx("div", {
      className: " fixed h-screen  right-0 w-full lg:w-[8%] cart_modalSection  border-l border-gray-300 ".concat(survey === true ? "lg:top-[60%] top-[48%] " : "", "  bottom-0 ").concat(onlyMobile ? "lg:hidden" : "", "$   ml-auto   z-40 \""),
      children: /*#__PURE__*/_jsx("div", {
        className: " ".concat(className ? "" : "py-4", " bg-white shadow-sm h-full rounded-t-2xl ").concat(survey === true ? "lg:rounded-t-2xl" : "", "   lg:rounded-none"),
        children: children
      })
    })]
  }), document.getElementById("sideBar"));
};
export default CartSidebar;